module.exports = __webpack_public_path__ + "img/violet_094.66ed0c2d.png";